import { API } from "../urls";

// Cookie-based auth: credentials:'include' ile access_token cookie otomatik gönderilir
const fetchOpts = { credentials: "include" };

/**
 * POS Rapor kök ekranı: KPI'lar, trend, sağlayıcı dağılımı ve "POS Entegrasyon
 * Detayları" tablosu (details[]).
 * SUPER_ADMIN tüm firmaların, COMPANY_ADMIN yalnızca kendi firmasının verisini görür
 * (kapsam filtresi tamamen backend tarafında uygulanır).
 * @param {string} period - week | month | quarter | year
 */
export const fetchPosAnalytics = async (period, startDate, endDate) => {
    const res = await fetch(API.get_pos_analytics(period, startDate, endDate), fetchOpts);
    return res.json();
};

/**
 * POS Rapor → sağlayıcı detayı: sağlayıcıyı kullanan firmaların sayfalı listesi.
 * @param {string} provider VirtualPos adı (PAYTR, GARANTI, ...)
 * @param {{period?:string,startDate?:string,endDate?:string,page?:number,size?:number,companyId?:string}} opts
 */
export const fetchPosCompanies = async (provider, opts = {}) => {
    const res = await fetch(API.get_pos_companies(provider, opts), fetchOpts);
    return res.json();
};

/**
 * POS Rapor → sağlayıcı → firma detayı: firmanın bu POS üzerinden işlem geçen
 * carilerinin sayfalı listesi.
 */
export const fetchPosCompanyAccounts = async (provider, companyId, opts = {}) => {
    const res = await fetch(API.get_pos_company_accounts(provider, companyId, opts), fetchOpts);
    return res.json();
};

/** Seçili kapsamın (POS / POS+firma / POS+firma+cari) özet KPI'ları. */
export const fetchPosScopeSummary = async (provider, opts = {}) => {
    const res = await fetch(API.get_pos_scope_summary(provider, opts), fetchOpts);
    return res.json();
};
